module.exports = __webpack_public_path__ + "img/circle-cross-subscribtion-plan.3e097953.svg";